// // import { useMutation, useQuery, useQueryClient } from "@tanstack/react-query";
// // import {
// //   createNewService,
// //   fetchAllService,
// //   fetchServiceCategory,
// //   fetchServiceKeywords,
// //   removeService,
// // } from "../../apis/partner";

// // export const useFetchAllServices = (partnerId) => {
// //   return useQuery({
// //     queryKey: ["services", partnerId],
// //     queryFn: () => fetchAllService(partnerId),
// //   });
// // };

// // export const useFetchCategory = () => {
// //   return useQuery({
// //     queryKey: ["category"],
// //     queryFn: () => fetchServiceCategory(),
// //   });
// // };

// // export const useFetchKeyword = () => {
// //   return useQuery({
// //     queryKey: ["keywords"],
// //     queryFn: () => fetchServiceKeywords(),
// //   });
// // };

// // export const useCreateService = (navigate) => {
// //   const queryClient = useQueryClient();
// //   return useMutation({
// //     mutationFn: ({ partnerId, formData }) =>
// //       createNewService(partnerId, formData),
// //     onSuccess: (newService, variables) => {
// //       const { partnerId } = variables;

// //       queryClient.refetchQueries({ queryKey: ["services", partnerId] });
// //       // queryClient.setQueryData(["services"], (oldData) => {
// //       //     const newData = [...oldData, newService];
// //       //     return newData;
// //       // });
// //       // dispatch(addEquipmentsData(newEquipment));
// //       navigate("/dashboard/services", { replace: true });
// //     },
// //     onError: (error) => {
// //       console.error("Error", error);
// //     },
// //   });
// // };

// // export const useRemoveService = () => {
// //   const queryClient = useQueryClient();

// //   return useMutation({
// //     mutationFn: ({ partnerId, serviceId }) =>
// //       removeService(partnerId, serviceId),
// //     onSuccess: (deletedService) => {
// //       queryClient.setQueryData(["services"], (oldData) => {
// //         if (oldData) {
// //           const newData = oldData.filter((service) => {
// //             return parseInt(service.service_id) !== parseInt(deletedService);
// //           });
// //           return newData;
// //         }
// //         console.log("Updated Old Data: ", oldData);

// //         return oldData;
// //       });
// //     },
// //     onError: (error) => {
// //       console.error(error);
// //     },
// //   });
// // };

// import { useMutation, useQuery, useQueryClient } from "@tanstack/react-query";
// import {
//   createNewService,
//   fetchAllService,
//   fetchServiceCategory,
//   fetchServiceKeywords,
//   removeService,
//   fetchServiceById, // Import the new API function
// } from "../../apis/partner";

// // Existing hooks
// export const useFetchAllServices = (partnerId) => {
//   return useQuery({
//     queryKey: ["services", partnerId],
//     queryFn: () => fetchAllService(partnerId),
//     enabled: !!partnerId, // Only fetch if partnerId is available
//   });
// };

// export const useFetchCategory = () => {
//   return useQuery({
//     queryKey: ["category"],
//     queryFn: () => fetchServiceCategory(),
//   });
// };

// export const useFetchKeyword = () => {
//   return useQuery({
//     queryKey: ["keywords"],
//     queryFn: () => fetchServiceKeywords(),
//   });
// };

// export const useCreateService = (navigate) => {
//   const queryClient = useQueryClient();
//   return useMutation({
//     mutationFn: ({ partnerId, formData }) =>
//       createNewService(partnerId, formData),
//     onSuccess: (newService, variables) => {
//       const { partnerId } = variables;
//       queryClient.refetchQueries({ queryKey: ["services", partnerId] });
//       navigate("/dashboard/services", { replace: true });
//     },
//     onError: (error) => {
//       console.error("Error", error);
//     },
//   });
// };

// export const useRemoveService = () => {
//   const queryClient = useQueryClient();
//   return useMutation({
//     mutationFn: ({ partnerId, serviceId }) =>
//       removeService(partnerId, serviceId),
//     onSuccess: (deletedService) => {
//       queryClient.setQueryData(["services"], (oldData) => {
//         if (oldData) {
//           const newData = oldData.filter((service) => {
//             return parseInt(service.service_id) !== parseInt(deletedService);
//           });
//           return newData;
//         }
//         console.log("Updated Old Data: ", oldData);
//         return oldData;
//       });
//     },
//     onError: (error) => {
//       console.error(error);
//     },
//   });
// };

// // New hook to fetch a single service by ID
// export const useFetchServiceById = (partnerId, serviceId) => {
//   return useQuery({
//     queryKey: ["service", partnerId, serviceId],
//     queryFn: () => fetchServiceById(partnerId, serviceId),
//     enabled: !!partnerId && !!serviceId, // Only fetch if both IDs are available
//   });
// };

// usePartnerService.js
import { useMutation, useQuery, useQueryClient } from "@tanstack/react-query";
import {
  createNewService,
  fetchAllService,
  fetchServiceCategory,
  fetchServiceKeywords,
  removeService,
  fetchServiceById,
} from "../../apis/partner";

export const useFetchAllServices = (partnerId) => {
  return useQuery({
    queryKey: ["services", partnerId],
    queryFn: () => fetchAllService(partnerId),
    enabled: !!partnerId,
  });
};

export const useFetchCategory = () => {
  return useQuery({
    queryKey: ["category"],
    queryFn: () => fetchServiceCategory(),
  });
};

export const useFetchKeyword = () => {
  return useQuery({
    queryKey: ["keywords"],
    queryFn: () => fetchServiceKeywords(),
  });
};

export const useCreateService = (navigate) => {
  const queryClient = useQueryClient();
  return useMutation({
    mutationFn: ({ partnerId, formData }) =>
      createNewService(partnerId, formData),
    onSuccess: (newService, variables) => {
      const { partnerId } = variables;
      queryClient.refetchQueries({ queryKey: ["services", partnerId] });
      navigate("/dashboard/services", { replace: true });
    },
    onError: (error) => {
      console.error("Error", error);
    },
  });
};

export const useRemoveService = () => {
  const queryClient = useQueryClient();
  return useMutation({
    mutationFn: ({ partnerId, serviceId }) =>
      removeService(partnerId, serviceId),
    onSuccess: (response, variables) => {
      const { partnerId } = variables;
      // Invalidate the services query to trigger a refetch
      queryClient.invalidateQueries({ queryKey: ["services", partnerId] });
    },
    onError: (error) => {
      console.error("Error removing service:", error);
    },
  });
};

export const useFetchServiceById = (partnerId, serviceId) => {
  return useQuery({
    queryKey: ["service", partnerId, serviceId],
    queryFn: () => fetchServiceById(partnerId, serviceId),
    enabled: !!partnerId && !!serviceId,
  });
};
